import { Statuses } from '@/V2/components/status/utils';

export const COMPLIANCE_RESULT = {
  PASS: 'PASS',
  FAIL: 'FAIL',
  INCONCLUSIVE: 'INCONCLUSIVE',
  NOT_APPLICABLE: 'NOT_APPLICABLE',
};

export const COMPLIANCE_RESULT_TO_READABLE_LABEL = {
  [COMPLIANCE_RESULT.PASS]: 'Pass',
  [COMPLIANCE_RESULT.FAIL]: 'Fail',
  [COMPLIANCE_RESULT.INCONCLUSIVE]: 'Inconclusive',
  [COMPLIANCE_RESULT.NOT_APPLICABLE]: 'Not Applicable',
};

export const COMPLIANCE_RESULT_TO_STATUS = {
  [COMPLIANCE_RESULT.PASS]: Statuses.SUCCESS,
  [COMPLIANCE_RESULT.FAIL]: Statuses.ERROR,
  [COMPLIANCE_RESULT.INCONCLUSIVE]: Statuses.WARNING,
  [COMPLIANCE_RESULT.NOT_APPLICABLE]: Statuses.INFO,
};

export const COMPLIANCE_COMPANY_CHECK_TYPE = {
  // the sort order in this object will be matched in the UI
  INCORPORATION_STATUS: 'INCORPORATION_STATUS',
  WEB_PRESENCE: 'WEB_PRESENCE',
  ADVERSE_MEDIA: 'ADVERSE_MEDIA',
  ADDRESS_VERIFICATION: 'ADDRESS_VERIFICATION',
  COUNTRY_RISK_SCREENING: 'COUNTRY_RISK_SCREENING',
  INDUSTRY_RISK_SCREENING: 'INDUSTRY_RISK_SCREENING',
  TRANSACTION_ACTIVITY: 'TRANSACTION_ACTIVITY',
  SOURCE_OF_FUNDS: 'SOURCE_OF_FUNDS',
  BCR_AUTHORIZATION: 'BCR_AUTHORIZATION',
};

export const COMPLIANCE_INDIVIDUAL_CHECK_TYPE = {
  DRIVING_LICENSE_EXPIRY_DATE: 'DRIVING_LICENSE_EXPIRY_DATE',
  CONNECTION_TO_COMPANY: 'CONNECTION_TO_COMPANY',
  CONNECTION_TO_ADDRESS: 'CONNECTION_TO_ADDRESS',
  ADVERSE_MEDIA: 'ADVERSE_MEDIA',
  ADVERSE_MEDIA_INDIVIDUAL: 'ADVERSE_MEDIA_INDIVIDUAL',
};

export const COMPLIANCE_ENTITY_TYPE = {
  COMPANY: 'COMPANY',
  INDIVIDUAL: 'INDIVIDUAL',
};

export const COMPLIANCE_COMPANY_SUB_CHECK_TYPE = {
  // Note: this is the old version of the new `WEBSITE_PRESENCE` check.
  // It is kept here for reference and to ensure backward compatibility.
  CROSS_VERIFY_PROFILE_WITH_WEBSITE: 'CROSS_VERIFY_PROFILE_WITH_WEBSITE',

  INCORPORATION_STATUS_FROM_WEB: 'INCORPORATION_STATUS_FROM_WEB',
  INCORPORATION_DOCS_RISK: 'INCORPORATION_DOCS_RISK',
  WEBSITE_PRESENCE: 'WEBSITE_PRESENCE',
  SOCIAL_MEDIA_PRESENCE: 'SOCIAL_MEDIA_PRESENCE',
  TRANSACTION_ACTIVITY_FROM_DOCUMENTS: 'TRANSACTION_ACTIVITY_FROM_DOCUMENTS',
  TRANSACTION_ACTIVITY_DOCS_RISK: 'TRANSACTION_ACTIVITY_DOCS_RISK',
  SOURCE_OF_FUNDS_FROM_WEB_SEARCH: 'SOURCE_OF_FUNDS_FROM_WEB_SEARCH',
  SOURCE_OF_FUNDS_FROM_DOCUMENTS: 'SOURCE_OF_FUNDS_FROM_DOCUMENTS',
  SOURCE_OF_FUNDS_DOCS_RISK: 'SOURCE_OF_FUNDS_DOCS_RISK',
  LETTER_OF_PERMISSION: 'LETTER_OF_PERMISSION',
  DOCUMENT_BASED_CONNECTION_TO_COMPANY: 'DOCUMENT_BASED_CONNECTION_TO_COMPANY',
  WEB_BASED_CONNECTION_TO_COMPANY: 'WEB_BASED_CONNECTION_TO_COMPANY',
  PO_BOX_ADDRESS: 'PO_BOX_ADDRESS',
  PRIVATE_MAILBOX_ADDRESS: 'PRIVATE_MAILBOX_ADDRESS',
  ADDRESS_VERIFICATION_FROM_WEB: 'ADDRESS_VERIFICATION_FROM_WEB',
};

export const COMPLIANCE_CHECK_TYPE_TO_ICON = {
  [COMPLIANCE_COMPANY_CHECK_TYPE.INCORPORATION_STATUS]: 'medium-file',
  [COMPLIANCE_COMPANY_SUB_CHECK_TYPE.INCORPORATION_STATUS_FROM_WEB]:
    'medium-search',
  [COMPLIANCE_COMPANY_SUB_CHECK_TYPE.INCORPORATION_DOCS_RISK]: 'medium-file',

  [COMPLIANCE_COMPANY_CHECK_TYPE.WEB_PRESENCE]: 'medium-map-earth-1',
  [COMPLIANCE_COMPANY_SUB_CHECK_TYPE.CROSS_VERIFY_PROFILE_WITH_WEBSITE]:
    'medium_arrows_transfer_diagonal',
  [COMPLIANCE_COMPANY_SUB_CHECK_TYPE.WEBSITE_PRESENCE]: 'medium-map-earth-1',
  [COMPLIANCE_COMPANY_SUB_CHECK_TYPE.SOCIAL_MEDIA_PRESENCE]: 'medium-search',

  [COMPLIANCE_COMPANY_CHECK_TYPE.ADVERSE_MEDIA]: 'medium_newspaper',

  [COMPLIANCE_COMPANY_CHECK_TYPE.ADDRESS_VERIFICATION]: 'medium_home_3',
  [COMPLIANCE_COMPANY_SUB_CHECK_TYPE.ADDRESS_VERIFICATION_FROM_WEB]:
    'medium-search',
  [COMPLIANCE_COMPANY_SUB_CHECK_TYPE.PO_BOX_ADDRESS]: 'medium_mail_postbox',
  [COMPLIANCE_COMPANY_SUB_CHECK_TYPE.PRIVATE_MAILBOX_ADDRESS]:
    'medium_mail_postbox',

  [COMPLIANCE_COMPANY_CHECK_TYPE.COUNTRY_RISK_SCREENING]:
    'medium-map-location-pin',
  [COMPLIANCE_COMPANY_CHECK_TYPE.INDUSTRY_RISK_SCREENING]: 'medium-building',

  [COMPLIANCE_COMPANY_CHECK_TYPE.TRANSACTION_ACTIVITY]: 'medium_money_wallet',
  [COMPLIANCE_COMPANY_SUB_CHECK_TYPE.TRANSACTION_ACTIVITY_FROM_DOCUMENTS]:
    'medium_money_wallet',
  [COMPLIANCE_COMPANY_SUB_CHECK_TYPE.TRANSACTION_ACTIVITY_DOCS_RISK]:
    'medium-file',

  [COMPLIANCE_COMPANY_CHECK_TYPE.SOURCE_OF_FUNDS]: 'medium-money-coins',
  [COMPLIANCE_COMPANY_SUB_CHECK_TYPE.SOURCE_OF_FUNDS_FROM_WEB_SEARCH]:
    'medium_browser_search',
  [COMPLIANCE_COMPANY_SUB_CHECK_TYPE.SOURCE_OF_FUNDS_FROM_DOCUMENTS]:
    'medium_money_coins',
  [COMPLIANCE_COMPANY_SUB_CHECK_TYPE.SOURCE_OF_FUNDS_DOCS_RISK]: 'medium-file',

  [COMPLIANCE_COMPANY_CHECK_TYPE.BCR_AUTHORIZATION]: 'medium_user_shield',

  [COMPLIANCE_COMPANY_SUB_CHECK_TYPE.LETTER_OF_PERMISSION]:
    'medium_mail_envelope',
  [COMPLIANCE_COMPANY_SUB_CHECK_TYPE.DOCUMENT_BASED_CONNECTION_TO_COMPANY]:
    'medium_file_check_3',
  [COMPLIANCE_COMPANY_SUB_CHECK_TYPE.WEB_BASED_CONNECTION_TO_COMPANY]:
    'medium_search_globe',

  [COMPLIANCE_INDIVIDUAL_CHECK_TYPE.DRIVING_LICENSE_EXPIRY_DATE]:
    'medium-calendar',
  [COMPLIANCE_INDIVIDUAL_CHECK_TYPE.CONNECTION_TO_COMPANY]:
    'medium-building-factory',
  [COMPLIANCE_INDIVIDUAL_CHECK_TYPE.CONNECTION_TO_ADDRESS]:
    'medium-map-location-pin',
  [COMPLIANCE_INDIVIDUAL_CHECK_TYPE.ADVERSE_MEDIA]: 'medium_newspaper',
};

export const CHECKS_README_URL =
  'https://docs.inscribe.ai/docs/business-compliance-analyst-checks';

export const CHECK_INFO = {
  [COMPLIANCE_ENTITY_TYPE.COMPANY]: {
    [COMPLIANCE_COMPANY_CHECK_TYPE.INCORPORATION_STATUS]: {
      description:
        "The Incorporation Status Check verifies the company's incorporation status through official records and document analysis.",
      url: `${CHECKS_README_URL}#incorporation-status-check`,
      subtypes: {
        [COMPLIANCE_RESULT.PASS]: 'Company is officially registered and active',
        [COMPLIANCE_RESULT.FAIL]: 'Company is no longer active',
        [COMPLIANCE_RESULT.INCONCLUSIVE]:
          'Could not confirm incorporation status',
        [COMPLIANCE_RESULT.NOT_APPLICABLE]: 'No business entity provided',
      },
    },
    [COMPLIANCE_COMPANY_CHECK_TYPE.WEB_PRESENCE]: {
      description:
        "The Web Presence Check validates the company's online footprint to confirm legitimacy and operational status",
      url: `${CHECKS_README_URL}#web-presence-check`,
      subtypes: {
        [COMPLIANCE_RESULT.PASS]: 'Active online presence found',
        [COMPLIANCE_RESULT.FAIL]: 'No credible web presence found',
        [COMPLIANCE_RESULT.INCONCLUSIVE]: 'Signals unclear or conflicting',
        [COMPLIANCE_RESULT.NOT_APPLICABLE]:
          'Not applicable to this business type',
      },
    },
    [COMPLIANCE_COMPANY_CHECK_TYPE.ADVERSE_MEDIA]: {
      description:
        'The Adverse Media for Company Check determines whether there is significant adverse media about the company that might indicate compliance concerns.',
      url: `${CHECKS_README_URL}#adverse-media-for-company-check`,
      subtypes: {
        [COMPLIANCE_RESULT.PASS]: 'No adverse media found',
        [COMPLIANCE_RESULT.FAIL]: 'Adverse media detected',
        [COMPLIANCE_RESULT.INCONCLUSIVE]: 'Media results unclear or unverified',
        [COMPLIANCE_RESULT.NOT_APPLICABLE]: 'Not applicable to this entity',
      },
    },
    [COMPLIANCE_COMPANY_CHECK_TYPE.ADDRESS_VERIFICATION]: {
      description:
        "The Address Verification Check verifies the company's address against official records and web sources",
      url: `${CHECKS_README_URL}#address-verification-check`,
      subtypes: {
        [COMPLIANCE_RESULT.PASS]: 'Address verified',
        [COMPLIANCE_RESULT.INCONCLUSIVE]: 'Address could not be verified',
        [COMPLIANCE_RESULT.NOT_APPLICABLE]: 'No address provided',
      },
    },

    [COMPLIANCE_COMPANY_CHECK_TYPE.COUNTRY_RISK_SCREENING]: {
      description:
        'The Country Risk Screening Check evaluates if the company is located in a high risk country or jurisdiction.',
      url: `${CHECKS_README_URL}#country-risk-screening-check`,
      subtypes: {
        [COMPLIANCE_RESULT.PASS]: 'Company is in a low-risk country',
        [COMPLIANCE_RESULT.FAIL]: 'Company is in a high-risk jurisdiction',
        [COMPLIANCE_RESULT.INCONCLUSIVE]: 'Country risk status unclear',
        [COMPLIANCE_RESULT.NOT_APPLICABLE]: 'Country not identified',
      },
    },
    [COMPLIANCE_COMPANY_CHECK_TYPE.INDUSTRY_RISK_SCREENING]: {
      description:
        'The Industry Risk Screening Check evaluates if the company operates within a high risk industry',
      url: `${CHECKS_README_URL}#industry-risk-screening-check`,
      subtypes: {
        [COMPLIANCE_RESULT.PASS]: 'Industry is considered low risk',
        [COMPLIANCE_RESULT.FAIL]: 'Industry is considered high risk',
        [COMPLIANCE_RESULT.INCONCLUSIVE]: 'Industry risk status unclear',
        [COMPLIANCE_RESULT.NOT_APPLICABLE]: 'Industry not specified',
      },
    },
    [COMPLIANCE_COMPANY_CHECK_TYPE.TRANSACTION_ACTIVITY]: {
      description:
        "The Transaction Activity Check verifies if the company's financial transactions align with the type of business",
      url: `${CHECKS_README_URL}#transaction-activity-check`,
      subtypes: {
        [COMPLIANCE_RESULT.PASS]: 'Activity aligns with business type',
        [COMPLIANCE_RESULT.FAIL]: 'Unusual or inconsistent transactions found',
        [COMPLIANCE_RESULT.INCONCLUSIVE]:
          'Transaction pattern could not be confirmed',
        [COMPLIANCE_RESULT.NOT_APPLICABLE]: 'Bank statements not provided',
      },
    },
    [COMPLIANCE_COMPANY_CHECK_TYPE.SOURCE_OF_FUNDS]: {
      description:
        "The Source of Funds Check validates the company's claimed source of funds",
      url: `${CHECKS_README_URL}#source-of-funds-check`,
      subtypes: {
        [COMPLIANCE_RESULT.PASS]: 'Source of funds is verifiable',
        [COMPLIANCE_RESULT.FAIL]: 'Claimed sources are unsubstantiated',
        [COMPLIANCE_RESULT.INCONCLUSIVE]: 'Insufficient evidence to verify',
        [COMPLIANCE_RESULT.NOT_APPLICABLE]: 'Not provided by applicant',
      },
    },
    [COMPLIANCE_COMPANY_CHECK_TYPE.BCR_AUTHORIZATION]: {
      description:
        'The BCR Authorization Check verifies if a person has the authorization for a business change request (BCR)',
      url: `${CHECKS_README_URL}`,
      subtypes: {
        [COMPLIANCE_RESULT.PASS]: 'BCR authorization verified',
        [COMPLIANCE_RESULT.FAIL]: 'BCR authorization failed',
        [COMPLIANCE_RESULT.INCONCLUSIVE]: 'BCR authorization status unclear',
        [COMPLIANCE_RESULT.NOT_APPLICABLE]: 'No BCR authorization required',
      },
    },
  },
  [COMPLIANCE_ENTITY_TYPE.INDIVIDUAL]: {
    [COMPLIANCE_INDIVIDUAL_CHECK_TYPE.CONNECTION_TO_COMPANY]: {
      description:
        'The Beneficial Owner Connection to Company Check analyzes whether there is a substantiated connection between a beneficial owner and the company.',
      url: `${CHECKS_README_URL}#beneficial-owner-connection-to-company-check`,
      subtypes: {
        [COMPLIANCE_RESULT.PASS]: 'Connection to the company established',
        [COMPLIANCE_RESULT.INCONCLUSIVE]:
          'Unable to establish connection to company',
        [COMPLIANCE_RESULT.NOT_APPLICABLE]: 'No individual identified',
      },
    },
    [COMPLIANCE_INDIVIDUAL_CHECK_TYPE.ADVERSE_MEDIA_INDIVIDUAL]: {
      description:
        'The Adverse Media for Individual Check identifies whether significant adverse media exists about a beneficial owner that might indicate compliance concerns.',
      url: `${CHECKS_README_URL}#adverse-media-for-individual-check`,
      subtypes: {
        [COMPLIANCE_RESULT.PASS]: 'No adverse media found',
        [COMPLIANCE_RESULT.FAIL]: 'Adverse media detected',
        [COMPLIANCE_RESULT.INCONCLUSIVE]: 'Media is unclear or unconfirmed',
        [COMPLIANCE_RESULT.NOT_APPLICABLE]: 'No individual detected',
      },
    },
    // deprecated, leaving for retro compatibility
    [COMPLIANCE_INDIVIDUAL_CHECK_TYPE.ADVERSE_MEDIA]: {
      description:
        'The Adverse Media for Individual Check identifies whether significant adverse media exists about a beneficial owner that might indicate compliance concerns.',
      url: `${CHECKS_README_URL}#adverse-media-for-individual-check`,
      subtypes: {
        [COMPLIANCE_RESULT.PASS]: 'No adverse media found',
        [COMPLIANCE_RESULT.FAIL]: 'Adverse media detected',
        [COMPLIANCE_RESULT.INCONCLUSIVE]: 'Media is unclear or unconfirmed',
        [COMPLIANCE_RESULT.NOT_APPLICABLE]: 'No individual detected',
      },
    },
  },
};
